// extracted by mini-css-extract-plugin
export default {"footContainer":"Footer_footContainer__Gz8YB","privacyMsg":"Footer_privacyMsg__MQwp6","copyRight":"Footer_copyRight__T2Yr2"};